import classNames from 'classnames'
import * as React from 'react'

import {withOneLineProp} from '../../../../contexts/oneLine'
import RowGroup from '../../Grid/RowGroup'

import styles from './BuildsHeader.css'

const getTitle = (...items: (string | false)[]) => items.filter(Boolean).join(' / ')

const Titles = {
  NUMBER: 'Build number',
  BRANCH: 'Branch',
  PATH: 'Build configuration',
  STATUS: 'Status',
  CHANGES: 'Changes',
  AGENT: 'Agent',
  STARTED: 'Started',
  FINISHED: 'Finished',
  DURATION: 'Duration',
}
type OwnProps = {
  withPath?: boolean | null | undefined
  withBranch?: boolean | null | undefined
  withAgent?: boolean | null | undefined
  withDuration?: boolean | null | undefined
  showExactDuration?: boolean | null | undefined
  className?: string
}
type Props = OwnProps & {
  oneLine: boolean
}

class BuildsHeader extends React.PureComponent<Props> {
  render() {
    const {className, oneLine, withPath, withBranch, withAgent, withDuration, showExactDuration} =
      this.props
    const classes = classNames(styles.buildsHeader, className, {
      [styles.oneLine]: oneLine,
    })
    return (
      <RowGroup>
        <div className={classes}>
          <div className={styles.number}>{Titles.NUMBER}</div>
          {oneLine ? (
            <>
              {withBranch === true && <div className={styles.branch}>{Titles.BRANCH}</div>}
              <div className={styles.status}>{Titles.STATUS}</div>
              <div className={styles.changes}>{Titles.CHANGES}</div>
              {withAgent === true && <div className={styles.agent}>{Titles.AGENT}</div>}
            </>
          ) : (
            <>
              <div className={styles.status}>
                {getTitle(
                  withBranch === true && Titles.BRANCH,
                  withPath === true && Titles.PATH,
                  Titles.STATUS,
                )}
              </div>
              <div className={styles.changes}>
                {getTitle(Titles.CHANGES, withAgent === true && Titles.AGENT)}
              </div>
            </>
          )}
          {withDuration === true && (
            <div className={styles.durationWrapper}>
              {showExactDuration === true ? (
                <>
                  <div className={styles.started}>{Titles.STARTED}</div>
                  <div className={styles.duration}>{Titles.DURATION}</div>
                </>
              ) : (
                <div className={styles.duration}>{getTitle(Titles.FINISHED, Titles.DURATION)}</div>
              )}
            </div>
          )}
          {oneLine ? <div className={styles.icons} /> : null}
        </div>
      </RowGroup>
    )
  }
}

export default React.memo<OwnProps>(withOneLineProp(BuildsHeader))
